/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from "react";
import axios from "axios";
import { BACKEND_URL } from "../../utils/util";
import { STORE_KEY } from "../../constant/constant";
import { useLoadingContext } from "../../store/context/loading-context";

const instance = axios.create({ baseURL: BACKEND_URL });

const AxiosInterceptor = ({ children }) => {
  const loadingCtx = useLoadingContext();

  // เก็บฟังก์ชัน loading ล่าสุดไว้ใน ref
  // interceptor ถูกลงทะเบียนครั้งเดียว ถ้า capture ฟังก์ชันจาก render แรกไว้ตรง ๆ
  // เวลา provider ถูก mount ใหม่  stopLoading จะไปสั่ง provider ตัวที่ตายแล้ว = overlay ค้าง
  const loadingRef = useRef(loadingCtx);
  loadingRef.current = loadingCtx;

  const idsRef = useRef(null);

  // ลงทะเบียนตอน render แรกเลย (ไม่รอ useEffect)
  // เพราะ effect ของลูกทำงานก่อน effect ของแม่ ถ้ารอ effect หน้าลูกจะยิง API
  // ออกไปก่อนที่ interceptor จะติด แล้ว Authorization header จะไม่ถูกแนบ
  if (idsRef.current === null) {
    const req = instance.interceptors.request.use(
      (config) => {
        const t = sessionStorage.getItem(STORE_KEY.authen);
        if (!config?.ignoreLoading) loadingRef.current?.startLoading?.();
        if (t) config.headers.Authorization = `Bearer ${t}`;
        if (config?.cancel) {
          const cancelTokenSource = axios.CancelToken.source();
          config.cancelToken = cancelTokenSource?.token;
        }
        return config;
      },
      (error) => {
        loadingRef.current?.stopLoading?.();
        return Promise.reject(error);
      }
    );

    const res = instance.interceptors.response.use(
      (response) => {
        loadingRef.current?.stopLoading?.();
        return response;
      },
      (error) => {
        loadingRef.current?.stopLoading?.();
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest?._retry) {
          if (originalRequest) originalRequest._retry = true;
          delete axios.defaults.headers.common["Authorization"];
        }

        return Promise.reject(error);
      }
    );

    idsRef.current = { req, res };
  }

  useEffect(() => {
    return () => {
      if (!idsRef.current) return;
      instance.interceptors.request.eject(idsRef.current.req);
      instance.interceptors.response.eject(idsRef.current.res);
      idsRef.current = null;
    };
  }, []);

  // เดิมเป็น `return isSet && children` ทำให้ไม่ render อะไรเลยจนกว่า effect จะทำงาน
  // ทุกครั้งที่ถูก mount ใหม่ = จอว่างอย่างน้อย 1 เฟรม
  return children;
};

export default instance;
export { AxiosInterceptor };
